import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';

export default function AdminNav() {
  const navigate = useNavigate();
  
  return (
    <nav className="hidden md:flex items-center gap-6">
      <Button 
        variant="ghost" 
        className="text-sm font-medium hover:text-primary transition-colors" 
        onClick={() => navigate('/admin')}
      >
        Dashboard
      </Button>
      <Button 
        variant="ghost" 
        className="text-sm font-medium hover:text-primary transition-colors" 
        onClick={() => navigate('/admin/talent')}
      >
        Talent
      </Button>
      <Button 
        variant="ghost" 
        className="text-sm font-medium hover:text-primary transition-colors" 
        onClick={() => navigate('/admin/companies')}
      >
        Companies
      </Button>
      <Button 
        variant="ghost" 
        className="text-sm font-medium hover:text-primary transition-colors" 
        onClick={() => navigate('/admin/projects')}
      >
        Projects
      </Button>
      <Button 
        variant="ghost" 
        className="text-sm font-medium hover:text-primary transition-colors" 
        onClick={() => navigate('/admin/support')}
      >
        Support
      </Button>
      <Button 
        variant="ghost" 
        className="text-sm font-medium hover:text-primary transition-colors" 
        onClick={() => navigate('/admin/utilities')}
      >
        Utilities
      </Button>
    </nav>
  );
}